import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink, useLocation, useMatches } from "react-router-dom";

interface CrumbHandle {
  crumb: string;
  dynamicCrumb?: boolean;
}

interface Crumb {
  label: string;
  to?: string;
}

export default function AppBreadcrumbs() {
  const matches = useMatches();
  const location = useLocation();
  const state = (location.state as any) || {};

  const crumbs: Crumb[] = [];

  for (const match of matches) {
    const handle = match.handle as CrumbHandle | undefined;
    if (!handle?.crumb) continue;

    if (handle.dynamicCrumb && state.designationName) {
      crumbs.push({
        label: "User Designations",
        to: state.parentPath,
      });
      crumbs.push({
        label:
          state.designationType === "MONTMEM"
            ? "Membership Vehicle"
            : `${state.designationName} Vehicle`,
      });
    } else {
      crumbs.push({ label: handle.crumb, to: match.pathname });
    }
  }

  if (crumbs.length <= 1) return null;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 2 }}
    >
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        if (isLast || !crumb.to) {
          return (
            <Typography key={i} fontSize="0.875rem" color="text.primary">
              {crumb.label}
            </Typography>
          );
        }
        return (
          <Link
            key={i}
            component={RouterLink}
            to={crumb.to}
            underline="hover"
            color="inherit"
            fontSize="0.875rem"
          >
            {crumb.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
